import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import { ENVIRONMENT } from '@iot-platform/core';
import { EmailTemplate, Environment } from '@iot-platform/models/common';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class EmailTemplateCellService {
  private readonly environment: Environment = inject(ENVIRONMENT);
  private readonly httpClient: HttpClient = inject(HttpClient);
  cachedTemplates: WritableSignal<EmailTemplate[]> = signal([]);
  templateIds = new Set<string>();

  getEmailTemplateById(templateId: string): Observable<EmailTemplate> {
    if (this.templateIds.has(templateId)) {
      return of(this.cachedTemplates().find((t) => t.id === templateId));
    } else {
      return this.httpClient.get<EmailTemplate>(`${this.environment.api.url}${this.environment.api.endpoints.notificationTemplates}/${templateId}`).pipe(
        tap((t) => {
          this.templateIds.add(t.id);
          this.cachedTemplates.update((cachedTemplates) => [...cachedTemplates, t]);
        })
      );
    }
  }
}
